"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectObserverWithMemory = void 0;
const subjectObserver_1 = require("./subjectObserver");
class SubjectObserverWithMemory extends subjectObserver_1.SubjectObserver {
    constructor() {
        super();
        this.oldData = [];
    }
    async subscribe(subscriber) {
        try {
            await super.subscribe(subscriber);
            return Promise.all(this.oldData.map((params) => subscriber(...params)));
        }
        catch (error) {
            return new Promise((resolve) => {
                resolve([]);
            });
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async publish(...params) {
        const promises = Promise.all(this.subscribers.map((subscriber) => {
            return subscriber(...params);
        }));
        this.oldData.push(params);
        return promises;
    }
}
exports.SubjectObserverWithMemory = SubjectObserverWithMemory;
//# sourceMappingURL=subjectObserverWithMemory.js.map